export default __webpack_public_path__ + "static/media/wine-icon-xl.fd2d98c2.png";